import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/Nikhil/Desktop/nodal/website/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting started`}</h1>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`Getting started with Nodal is super easy. Just install it as a Node package:`}</p>
    <pre><code parentName="pre" {...{}}>{`npm install nodal
`}</code></pre>
    <h2 {...{
      "id": "using-a-preset"
    }}>{`Using a preset`}</h2>
    <p>{`You can immediately start laying out graphs using one of our presets. This option is great for application designers with little to no experience in graph layout.`}</p>
    <p><em parentName="p">{`TODO: Add data and code for a preset.`}</em></p>
    <h2 {...{
      "id": "using-a-custom-algorithm"
    }}>{`Using a custom algorithm`}</h2>
    <p>{`You can also configure your own custom layout algorithm. This option is great for designers that really want to tweak the aesthetics for their use case, and for researchers developing novel algorithms.`}</p>
    <p>{`Here are some steps to get started:`}</p>
    <ol>
      <li parentName="ol">{`Take a look at the `}<a parentName="li" {...{
          "href": "/nodal/"
        }}>{`interactive demo`}</a>{` on the home page. It shows a working example of how to integrate different features into a layout.`}</li>
      <li parentName="ol">{`Familizarize yourself with the `}<a parentName="li" {...{
          "href": "/nodal/guides/architecture"
        }}>{`architecture`}</a>{` and `}<a parentName="li" {...{
          "href": "/nodal/api"
        }}>{`abstractions`}</a>{` in the library.`}</li>
      <li parentName="ol">{`Read more about the `}<a parentName="li" {...{
          "href": "/nodal/guides/further-reading"
        }}>{`research`}</a>{` that forms the framework for Nodal's approach.`}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      